import React, {useState} from "react"
import {Row, Col} from "react-bootstrap"
import CustomToggle from "../../helpers/CustomToggle";
import {IoChevronDown, IoTrashOutline} from "react-icons/io5";
import axios from "axios";
import {baseURL} from "../../helpers/baseURL";
import Cookies from "js-cookie";
import {fetchUser, getApps} from "../../redux/actions";
import {useDispatch} from "react-redux";

const openOptions = [
    {
        value: "first",
        label: "Move to Todo / first column",
        hint: "List → To do. Scrum or Kanban → first board column.",
    },
    {
        value: "none",
        label: "Do nothing",
        hint: "Leave linked Claritask tasks where they are.",
    },
];

const closeOptions = [
    {
        value: "last",
        label: "Move to Completed / last column",
        hint: "List → Completed. Scrum or Kanban → last board column.",
    },
    {
        value: "none",
        label: "Do nothing",
        hint: "Leave linked Claritask tasks where they are.",
    },
];

const selectWrapStyle = {
    position: "relative",
    display: "inline-block",
    maxWidth: "100%",
};

const selectStyle = {
    width: "auto",
    minWidth: "280px",
    maxWidth: "100%",
    display: "inline-block",
    paddingRight: "36px",
    appearance: "none",
    WebkitAppearance: "none",
    MozAppearance: "none",
    backgroundImage: "none",
    cursor: "pointer",
};

const chevronStyle = {
    position: "absolute",
    right: "12px",
    top: "50%",
    transform: "translateY(-50%)",
    pointerEvents: "none",
    color: "#64748b",
    fontSize: "16px",
};

const normalizeOpen = (value) => (value === "none" ? "none" : "first");
const normalizeClose = (value) => (value === "none" ? "none" : "last");

const ActionSelect = ({id, value, onChange, options}) => {
    const selected = options.find((opt) => opt.value === value) || options[0];

    return (
        <div>
            <div style={selectWrapStyle}>
                <select
                    id={id}
                    className="form-control"
                    style={selectStyle}
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                >
                    {options.map((opt) => (
                        <option key={`${id}-${opt.value}`} value={opt.value}>
                            {opt.label}
                        </option>
                    ))}
                </select>
                <IoChevronDown style={chevronStyle} aria-hidden="true" />
            </div>
            {selected?.hint && (
                <p style={{fontSize: "12px", color: "#94a3b8", marginTop: "6px", marginBottom: 0}}>
                    {selected.hint}
                </p>
            )}
        </div>
    );
};

const AppSettings = ({app, hideModal, user}) => {
    if(app === "No company found from this hash."){
        return <div>Please retry connection, prev connection is lost</div>
    }
    const dispatch = useDispatch()
    const linkedCompanyId = app?.company_details?.[0]?.company_id ?? null
    const [selected, setSelected] = useState(linkedCompanyId)
    // API returns boolean; older UI compared with === 1 and always looked inactive
    const [active, setActive] = useState(Boolean(user.claritask_active))
    const [onOpen, setOnOpen] = useState(normalizeOpen(user.claritask_on_open))
    const [onClose, setOnClose] = useState(normalizeClose(user.claritask_on_close))
    const [saving, setSaving] = useState(false)

    const onChangeToggle = () => {
        setActive(!active)
    }
    const handleUpdate = async (e) => {
        e.preventDefault()
        const wasActive = Boolean(user.claritask_active)
        const claritask_company_id = selected
        const headers = {Authorization: `Bearer ${Cookies.get('access_token')}`}

        setSaving(true)
        try {
            // claritask-active toggles server-side — only call when the user changed it
            if (active !== wasActive) {
                await axios.post(`${baseURL}claritask-active`, { active_app: active ? 1 : 0 }, {headers})
            }

            // sync-link regenerates claritask_key — only when company selection changed
            if (claritask_company_id && claritask_company_id !== linkedCompanyId) {
                await axios.post(`${baseURL}sync-link`, { claritask_company_id }, {headers})
            }

            await axios.post(`${baseURL}claritask-ticket-actions`, {
                claritask_on_open: onOpen,
                claritask_on_close: onClose,
            }, {headers})

            dispatch(fetchUser())
            dispatch(getApps())
            hideModal()
        } catch (err) {
            console.error(err)
        } finally {
            setSaving(false)
        }
    }

    const companies = app?.company_details?.[0]
    const otherCompanies = companies?.other_companies || []

    if (!companies || otherCompanies.length === 0) {
        return (
            <Row>
                <Col xs={12}>
                    <div className="settings-app-container">
                        <h1>Settings</h1>
                        <p>Could not load Claritask company details. Try refreshing the page or reconnecting the app.</p>
                        <button type="button" className="btn cancel-button" onClick={hideModal}>Close</button>
                    </div>
                </Col>
            </Row>
        )
    }

    return(
        <Row>
            <Col xs={12}>
                <form onSubmit={(e) => handleUpdate(e)}>
                    <div className="settings-app-container">
                        <img src={app.logo} alt=""/>
                        <div className="settings-app-container-header">
                            <h1>Settings</h1>
                            <div className="d-flex align-items-center ">
                                <div className="settings-app-deactive">
                                    <input type="checkbox" id="deactiveApp2" name="active" className="custom-checkbox-toggle" onChange={() => onChangeToggle()} checked={active}/>
                                    <CustomToggle
                                        first={1}
                                        second={2}
                                        on={active ? "Deactive" : "Active"}
                                        id="deactiveApp2"
                                    />
                                </div>
                                <button className="btn delete-connection-btn">
                                    Delete
                                    <IoTrashOutline/>
                                </button>
                            </div>
                        </div>
                        <div>
                            <h6 style={{marginBottom: '30px'}}><span className="system-name">Claritick</span> is linked with {app.name} using <span className="system-email-connected">({otherCompanies[0]?.user_email || 'unknown'})</span> e-mail and is successfully connected to:</h6>
                            <h6>Company:</h6>
                            {otherCompanies.map(company => (
                                <div key={`check-company${company.company_id}`} className="company-list-check" style={{border: selected === company.company_id && "1px solid #18AEE3"}}>
                                    <label className="checkRole mb-0">
                                        <input className="input-var" name="company" type="radio" value={company.company_id} onChange={() => setSelected(company.company_id)} checked={selected === company.company_id ? true : false}/>
                                        <span className="check-role"></span>
                                    </label>
                                    <p>{company.company_name}</p>
                                </div>
                            ))}
                        </div>
                        <div style={{marginTop: '28px'}}>
                            <h6 style={{marginBottom: '8px'}}>Linked Claritask tasks</h6>
                            <p style={{fontSize: '13px', color: '#64748b', marginBottom: '18px'}}>
                                Only tickets that already have linked Claritask tasks are affected.
                                Behavior depends on the Claritask project type: List uses Todo/Completed;
                                Scrum and Kanban move the task to the first or last board column.
                            </p>
                            <div style={{marginBottom: '18px'}}>
                                <label htmlFor="claritaskOnOpen" style={{display: 'block', fontWeight: 600, marginBottom: '6px'}}>
                                    When ticket is opened
                                </label>
                                <ActionSelect
                                    id="claritaskOnOpen"
                                    value={onOpen}
                                    onChange={setOnOpen}
                                    options={openOptions}
                                />
                            </div>
                            <div>
                                <label htmlFor="claritaskOnClose" style={{display: 'block', fontWeight: 600, marginBottom: '6px'}}>
                                    When ticket is closed
                                </label>
                                <ActionSelect
                                    id="claritaskOnClose"
                                    value={onClose}
                                    onChange={setOnClose}
                                    options={closeOptions}
                                />
                            </div>
                        </div>
                        <div className="modal-footer pt-4 justify-content-start">
                            <button type="submit" className="btn save-button createCustomerCard" disabled={saving}>
                                {saving ? "Saving..." : "Save"}
                            </button>
                            <button type="button" className="btn cancel-button" onClick={hideModal}>Cancel</button>
                        </div>
                    </div>
                </form>
            </Col>
        </Row>
    )
}
export default AppSettings
